@if (logo()) {
  <img [src]="logo()" [alt]="name()" />
} @else {
  <span>{{ initials() }}</span>
}
